import React from 'react';
import { Link } from 'react-router-dom';
export function HeroSection() {
  return <section className="relative h-screen flex items-center overflow-hidden" data-id="element-159">
      {/* Background Video/Image */}
      <div className="absolute inset-0 z-0" data-id="element-160">
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/70 to-black" data-id="element-161"></div>
        <img src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Trading background" className="w-full h-full object-cover" data-id="element-162" />
      </div>
      <div className="container mx-auto px-4 z-10 mt-16" data-id="element-163">
        <div className="max-w-3xl" data-id="element-164">
          <h1 className="text-4xl md:text-6xl font-bold mb-6" data-id="element-165">
            Learn Trading from World-Class Experts
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200" data-id="element-166">
            Master forex trading strategies with lessons from the industry's top
            performers.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-167">
            <Link to="/signup" className="bg-red-600 text-white px-6 py-3 rounded font-medium text-lg hover:bg-red-700 transition-colors text-center" data-id="element-168">
              Get Started
            </Link>
            <Link to="/classes" className="border border-red-600 px-6 py-3 rounded font-medium text-lg hover:bg-red-600/10 transition-colors text-center" data-id="element-169">
              Explore Classes
            </Link>
          </div>
        </div>
      </div>
    </section>;
}